import { StyleSheet } from 'react-native';

export const getSketchFrameStyles = () =>
  StyleSheet.create({
    frame: {
      position: 'relative',
    },
    border: {
      position: 'absolute',
      top: 0,
      left: 0,
    },
  });
